import { useEffect } from 'react'
import { createPortal } from 'react-dom'

interface TutorialHeaderProps {
  onClose: () => void
  isCompletion?: boolean
}

export function TutorialHeader({ onClose, isCompletion = false }: TutorialHeaderProps) {
  useEffect(() => {
    document.body.classList.add('tutorial-header-active')
    return () => {
      document.body.classList.remove('tutorial-header-active')
    }
  }, [])

  return createPortal(
    <div
      data-tutorial-header="true"
      className={isCompletion ? 'tutorial-header--completion' : ''}
    >
      <h1>
        Onboarding tutorial
      </h1>
      <button
        type="button"
        onClick={onClose}
      >
        ×
      </button>
    </div>,
    document.body,
  )
}
